import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FaCheck } from 'react-icons/fa';
import { Button } from '@mui/material';
import PreviewButtonPopup from './PreviewButtonPopup'

const useStyles = makeStyles((theme) => ({
    sidebar: {
        width: '5%',
        height: '30vh',
        position: 'absolute',
        marginLeft: 15,
        right: 0,
        top: 0,
        background: '#F3F6F9',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Poppins',
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: '24px',
        textAlign: 'left',
        color: 'rgba(187, 200, 8, 1)',
        opacity: 0.9,
        borderRadius: 8.16,
        textOrientation: 'mixed',
        writingMode: 'horizontal-tb',

    },
    content: {
        background: 'rgba(187, 200, 8, 1)',
        transform: 'rotate(90deg)',
        //width: 577,
        height: 45,
        paddingLeft: 13,
        paddingTop: 6,
        paddingRight: 20,
        borderRadius: 8.16,
        whiteSpace: 'nowrap',
        display: 'flex',
        alignItems: 'center',
        color:"rgba(255, 255, 255, 1)"
    },
    faCheck: {
        border: '3px solid rgba(255, 255, 255, 1)',
        paddingLeft: 3,
        paddingRight: 3,
        paddingTop: 2,
        paddingBottom: 0,
        borderRadius: 8,
        marginRight: 8,
    },
}));

const PreviewButton = ({ claimData, className  }) => {
    const classes = useStyles();
    const [showPopup, setShowPopup] = useState(false);

    const handleClick = () => {
        setShowPopup(true);
    };

    const handleClose = () => {
        setShowPopup(false);
    };

    return (
        <>
            <Button className={`${classes.sidebar} ${className}`} onClick={handleClick}>
        <span className={classes.content}>
          <div className={classes.faCheck}><FaCheck /></div>
          Aperçu Sinistre
        </span>
            </Button>
            {showPopup && (
                <PreviewButtonPopup open={showPopup} onClose={handleClose} infoSinistre={claimData} />
            )}
        </>
    );
};

export default PreviewButton;
